import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, useMediaQuery, Card, CardContent, CardActions, Rating, Button, Collapse, useTheme, InputBase, IconButton, Divider } from "@mui/material"
import Header from './Header'
import FlexBetween from './FlexBetween'
import { UserAuth } from '../context/AuthContext'
import { useLocation, useNavigate } from 'react-router-dom'
import { motion } from "framer-motion";
import Grid from '@mui/material/Unstable_Grid2';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TablaGestionAbierta from './tablas/TablaGestionAbierta'
import { COLUMNSGESTIONESABIERTAS, COLUMNSGESTIONESRESUELTAS } from '../columnas/columnaGH'
import ModalGestionResuelta from './modales/ModalGestionResuelta'
import TokenContext from '../context/TokenContext'
import { misIndicentesAbiertos, misIndicentesResueltos, nuevaIncidencia } from '../Redux/ghResponde'

import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import TablaGestionResuelta from './tablas/TablaGestionResuelta'
import ModalIncidenteAbierto from './modales/ModalIncidenteAbierto'
import ModalAdjuntos from './modales/ModalAdjuntos'
import { analytics } from '../Firebase'

import { toast } from "react-toastify"
import { cargarAdjuntoSolicitud } from '../Redux/solicitudes'

const GDResponde = () => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)
    const [valuePrimerTab, setValuePrimerTab] = React.useState('1'); //value del tablist
    const { empleado } = UserAuth() //empleado contiene el usuarioPortalRh y empleadoid, esos dos valores son necesarios para las consultas a los fetch.
    const location = useLocation();
    const [abrir, setAbrir] = React.useState(false)
    const [selectedFiles, setSelectedFiles] = React.useState([]);

    const [OpenModal, setOpenModal] = React.useState(false)
    const [gr, setGr] = React.useState([])

    const [openAdjuntos, setOpenAdjuntos] = React.useState(false)
    const [idAdjuntos, setIdAdjuntos] = React.useState(false)

    const [gestionesAbiertas, setGestionesAbiertas] = React.useState([])
    const [columnasGestionAbierta, setColumnasGestionAbierta] = React.useState(COLUMNSGESTIONESABIERTAS)
    const [loading1, setLoading1] = React.useState(false)
    const gaSelector = useSelector(store => store.ghResponde.incidentesAbiertos)
    const loadingGaSelector = useSelector(store => store.ghResponde.loadingIa)

    const [gestionesResueltas, setGestionesResueltas] = React.useState([])
    const [columnasGestionResuelta, setColumnasGestionResuelta] = React.useState(COLUMNSGESTIONESRESUELTAS)
    const [loading2, setLoading2] = React.useState(false)
    const grSelector = useSelector(store => store.ghResponde.incidentesResueltos)
    const loadingGrSelector = useSelector(store => store.ghResponde.loadingIr)

    const [targetGA, setTargetGA] = React.useState({})

    React.useEffect(() => {
        if (empleado && empleado.usuarioPortalRh) {
            // Extraer el nombre de usuario de la dirección de correo electrónico
            const userEmail = empleado.usuarioPortalRh;
            const userName = userEmail.split('@')[0];

            // Enviar el evento a Firebase Analytics con el nombre de usuario
            analytics.logEvent('screen_view', {
                screen_name: location.pathname,
                user_email: userName,
            });
        }
    }, [empleado, location]);

    React.useEffect(() => {
        if (token) {
            dispatch(misIndicentesAbiertos(token, empleado.empleadoid))
            dispatch(misIndicentesResueltos(token, empleado.empleadoid))
        }
    }, [token])

    React.useEffect(() => {
        setLoading1(loadingGaSelector)
        setLoading2(loadingGrSelector)
    }, [loadingGaSelector, loadingGrSelector])

    React.useEffect(() => {
        if (gaSelector.length > 0) {
            var array = []
            gaSelector.forEach(element => {
                var objeto = {
                    id: element.new_incidenciasdocentesid,
                    new_name: element.new_name,
                    new_origen: element["new_origen@OData.Community.Display.V1.FormattedValue"],
                    new_altadeincidente: element["new_altadeincidente@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeincidencia: element["new_tipodeincidencia@OData.Community.Display.V1.FormattedValue"],
                    new_vencimiento: element["new_vencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_empleado_value: element._new_empleado_value,
                    new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
                    _new_tema_value: element._new_tema_value,
                    new_tema: element["_new_tema_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setGestionesAbiertas(array)
        }
    }, [gaSelector])

    React.useEffect(() => {
        if (grSelector.length > 0) {
            var array = []
            grSelector.forEach(element => {
                var objeto = {
                    id: element.new_incidenciaid,
                    createdon: element["createdon@OData.Community.Display.V1.FormattedValue"],
                    new_fecharesolucion: element["new_fecharesolucion@OData.Community.Display.V1.FormattedValue"],
                    new_name: element.new_name,
                    new_resolucion: element.new_resolucion,
                    new_origen: element["new_origen@OData.Community.Display.V1.FormattedValue"],
                    new_tipodeincidencia: element["new_tipodeincidencia@OData.Community.Display.V1.FormattedValue"],
                    new_vencimiento: element["new_vencimiento@OData.Community.Display.V1.FormattedValue"],
                    _new_empleado_value: element._new_empleado_value,
                    new_empleado: element["_new_empleado_value@OData.Community.Display.V1.FormattedValue"],
                    _new_tema_value: element._new_tema_value,
                    new_tema: element["_new_tema_value@OData.Community.Display.V1.FormattedValue"]
                }
                array.push(objeto)
            });
            setGestionesResueltas(array)
        }
    }, [grSelector])

    const handleChangePrimerTAB = (event, newValue) => {
        setValuePrimerTab(newValue);
    };

    //abrir modal
    const handleOpenModalTable = () => {
        setAbrir(true)
    }
    //ABRIR MODAL GA ROW
    const handleOpenGA = (id) => {
        setTargetGA(gestionesAbiertas?.find((item) => item.id === id))
        setAbrir(true)
    }
    
    //cerrar modal
    const handleCloseModalTable = () => {
        setTargetGA({})
        setAbrir(false)
    }

    const handleOpenModalGH = (id, row) => {
        setGr(row);
        setOpenModal(true);
    };

    //cerrar modal
    const handleCloseModalGH = () => {
        setOpenModal(false)
    }

    const handleOpenAdjuntos = (id) => {
        setIdAdjuntos(id)
        setOpenAdjuntos(true)
    }

    const handleCloseAdjuntos = () => {
        setIdAdjuntos('')
        setOpenAdjuntos(false)
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -100 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <Box
                m="1.5rem 2.5rem"
            >
                <Header title={"GD Responde"} subtitle="¿Necesitas preguntar, solicitar o alertar sobre un inconveniente a Gestión Docente? Hacelo a través de esta sección.  " />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                        <Box sx={{ p: 2 }}>
                            <TabContext value={valuePrimerTab}>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <TabList
                                        aria-label="scrollable force tabs example"
                                        onChange={handleChangePrimerTAB} variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        textColor="secondary"
                                        indicatorColor="secondary"
                                    >
                                        <Tab label="Mis Gestiones Abiertas" value="1" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                        <Tab label="Mis Gestiones Resueltas" value="2" sx={{ fontWeight: 'bold', fontSize: '16px' }} />
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    {
                                        loading1 ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    py: 2
                                                }}>
                                                <CircularProgress color="secondary" />
                                            </Box>
                                        )
                                            :
                                            // gestionesAbiertas.length > 0 ? (
                                            // <TablaGestionAbierta columnas={columnasGestionAbierta} lineas={gestionesAbiertas} handleOpen={handleOpenModalTable} />
                                            <TablaGestionResuelta columnas={columnasGestionAbierta} lineas={gestionesAbiertas} handleOpenNuevo={handleOpenModalTable} handleOpen={handleOpenGA} handleOpenAdjuntos={handleOpenAdjuntos} acciones={true} agregar={true} />

                                        // ) :
                                        //     <Alert severity="info">
                                        //         <AlertTitle>Info</AlertTitle>
                                        //         Aún no tienes registros de gestiones — <strong>Abiertas</strong>.
                                        //     </Alert>

                                    }
                                </TabPanel>
                                <TabPanel value="2">
                                    {
                                        loading2 ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    height: '100%',
                                                    py: 2
                                                }}>
                                                <CircularProgress color="secondary" />
                                            </Box>
                                        )
                                            : gestionesResueltas.length > 0 ? (
                                                // <TablaGestionResuelta columnas={columnasGestionResuelta} lineas={gestionesResueltas} />
                                                <TablaGestionResuelta columnas={columnasGestionResuelta} lineas={gestionesResueltas} handleOpen={handleOpenModalGH} handleOpenAdjuntos={handleOpenAdjuntos} acciones={true} />

                                            ) :
                                                <Alert severity="info">
                                                    <AlertTitle>Info</AlertTitle>
                                                    Aún no tienes registros de gestiones — <strong>Resueltas</strong>.
                                                </Alert>

                                    }
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <ModalIncidenteAbierto open={abrir} handleClose={handleCloseModalTable} data={targetGA} />
            <ModalGestionResuelta open={OpenModal} handleClose={handleCloseModalGH} data={gr} />
            <ModalAdjuntos open={openAdjuntos} handleClose={handleCloseAdjuntos} id={idAdjuntos}/>
        </motion.div>
    )
}

export default GDResponde